<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold Склады

  .container.mt-5
    .row
      .col
        button.styled(@click="$modal.show('new_store')") Создать новый склад
    .row.mt-4
    .col-sm(v-if="warehouse_loading")
      .loader_holder(style="margin: 0 auto; width: 200px")
        object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
    .white_block.warehouse(v-for="warehouse of warehouses")
      .row
        .col-4
          .name {{ warehouse.name }}
        .col.my-auto
          .notification(
            v-for="n of warehouse.notifications",
            :c="`${n.color || ''}`"
          ) 
            <i class="fal fa-info-circle"></i> 
            | {{ n.text }}
        .col-2.text-right
          router-link(:to="{ path: '/inventory/warehouses/' + warehouse.id }")
            button.styled Открыть склад

  modal.new_store(name="new_store", height="auto", :adaptive="true") 
    .close(@click="$modal.hide('new_store')")
      i.fal.fa-times
    .container
      .row
        .col
          h2 Создание нового склада
          .content
            .inputModule
              input-module(
                type="text",
                title="Название склада",
                v-model="new_name"
              ) 
            br
            button.styled.createLink(
              :disabled="new_name == ''",
              @click="createWarehouse"
            ) Создать склад
            br
            br
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {},

  data() {
    return {
      warehouses: [],
      warehouse_loading: true,
      new_name: "",
    };
  },

  computed: {},

  async mounted() {
    await this.loadWarehouses();
  },

  methods: {
    async loadWarehouses() {
      let warehouses = (
        await apiDriver.services.api.get("inventory", "store/list", {
          notifications: true,
        })
      ).data.list;
      console.log("warehouses:", warehouses);
      this.warehouses = warehouses;
      this.warehouse_loading = false;
    },
    async createWarehouse() {
      this.$toast.info("Склад создаётся...");
      let created = await apiDriver.services.api.post(
        "inventory",
        "store/create",
        { name: this.new_name }
      );
      if (!created) {
        this.$toast.error("Ошибка создания склада.");
        return;
      }
      created = created.data;
      this.new_name = "";
      this.warehouses.push(created.store);
      this.$toast.success("Склад создан!");
      this.$toast.success(
        "Пользователь для Раздачи Кодов на новый склад создан."
      );
      this.$modal.hide("new_store");
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.warehouse {
  .name {
    font-size: 20pt;
  }

  .notification {
    background: black;
    margin: 2px;
    padding: 3px 8px;
    border-radius: 100px;
    color: white;
    display: inline-block;
    font-size: 11px;

    &[c='green'] {
      background: #4caf50;
    }

    &[c='orange'] {
      background: #FF9800;
    }

    &[c='red'] {
      background: #f44336;
    }

    i {
      margin-right: 2px;
    }
  }
}
</style>
